export default {
  title: "Benachrichtigungen",
  subtitle: "Überwacht laufend Ihre Projekte und meldet Handlungsbedarf, bevor er teuer wird",
  empty: "Keine offenen Meldungen",
  empty_unread: "Keine ungelesenen Meldungen",
  empty_filtered: "Keine Meldungen für diese Auswahl",
  loading: "Meldungen werden geladen …",
  show_all: "Alle anzeigen",
  mark_all_read: "Alle als gelesen markieren",
  mark_read: "Als gelesen markieren",
  read: "Gelesen",
  unread: "ungelesen",
  evaluated_at: "Zuletzt geprüft: {time}",
  severity: {
    INFO: "Information",
    WARNING: "Warnung",
    CRITICAL: "Kritisch",
  },
  severity_meaning: {
    INFO: "Allgemeine Hinweise",
    WARNING: "Handlungsbedarf",
    CRITICAL: "Sofortiger Eingriff nötig",
  },
  filter: {
    severity: "Dringlichkeit",
    type: "Art",
    all: "Alle",
  },
  types: {
    UNBILLED_SERVICES: "Nicht abgerechnete Leistungen",
    MISSING_CONSTRUCTION_REPORT: "Überfällige [[cr.pl]]",
    PROJECT_LOSS_RISK: "Drohender Verlust",
    PROJECT_BUDGET_AT_RISK: "Budget gefährdet",
    PROJECT_COST_DRIFT: "Marge sinkt (Kostendrift)",
    MONTAGE_BEHIND_PLAN: "Leistungsfortschritt im Rückstand",
    TIME_ENTRY_MISSING: "Fehlende Zeiterfassung",
    TIME_ENTRY_APPROVAL_PENDING: "Zeiten warten auf Freigabe",
    TIME_ENTRY_RUNNING_STALE: "Stempeluhr läuft noch",
    DOCUMENT_DUE: "Dokumente laufen ab",
  },
  messages: {
    TIME_ENTRY_MISSING: "Für {employee} fehlen {count} Arbeitstage, der älteste seit {days} Tagen ({oldestDate}).",
    TIME_ENTRY_APPROVAL_PENDING:
      "{count} erfasste Tage von {employees} Mitarbeitern warten auf Freigabe, der älteste seit {days} Tagen.",
    // Kein Vorwurf, sondern die Folge: bis ausgestempelt ist, kann derjenige keinen neuen Tag beginnen.
    TIME_ENTRY_RUNNING_STALE:
      "Die Stempeluhr von {employee} läuft seit dem {startedOn} ({days} Tage). Bis zum Ausstempeln " +
      "kann kein neuer Tag begonnen werden.",
    UNBILLED_SERVICES:
      "{count} [[hwr.pl]] sind seit {days} Tagen nicht abgerechnet ([[hwr:ältester/älteste/ältestes]] vom {oldestDate}).",
    MISSING_CONSTRUCTION_REPORT:
      "An {count} Arbeitstagen fehlt [[cr:ein/eine/ein]] [[cr]]. Ältester offener Tag: {oldestDate} (seit {days} Tagen).",
    PROJECT_LOSS_RISK:
      "Die erwartete Marge liegt bei {marginPercent} %: {costToDate} {currency} Kosten stehen {contractValue} {currency} Auftragsvolumen gegenüber.",
    PROJECT_BUDGET_AT_RISK:
      "{usedPercent} % des Budgets sind verbraucht: {costToDate} {currency} von {budget} {currency}. Es ist kein Fertigstellungsgrad erfasst.",
    PROJECT_BUDGET_AT_RISK_MONTAGE:
      "{usedPercent} % des Budgets sind verbraucht, aber erst {completionPercent} % der Stückliste montiert: {leadPoints} Prozentpunkte Vorlauf ({costToDate} {currency} von {budget} {currency}).",
    PROJECT_BUDGET_AT_RISK_SERVICE_CATALOG:
      "{usedPercent} % des Budgets sind verbraucht, laut Leistungskatalog aber erst {completionPercent} % fertiggestellt: {leadPoints} Prozentpunkte Vorlauf ({costToDate} {currency} von {budget} {currency}).",
    PROJECT_BUDGET_AT_RISK_MANUAL:
      "{usedPercent} % des Budgets sind verbraucht bei {completionPercent} % Fertigstellung: {leadPoints} Prozentpunkte Vorlauf ({costToDate} {currency} von {budget} {currency}).",
    PROJECT_BUDGET_AT_RISK_LEGACY:
      "{usedPercent} % des Budgets sind verbraucht: {costToDate} {currency} von {budget} {currency}.",
    PROJECT_BUDGET_AT_RISK_OVER:
      "Das Budget ist überschritten: {costToDate} {currency} von {budget} {currency} ({usedPercent} %).",
    PROJECT_COST_DRIFT:
      "Die erwartete Marge ist in den letzten {windowDays} Tagen um {marginDropPercent} Prozentpunkte auf {marginPercent} % gefallen.",
    MONTAGE_BEHIND_PLAN:
      "Der Montagefortschritt liegt bei {actualPercent} % statt der erwarteten {expectedPercent} %: {pendingCount} von {elementCount} Positionen stehen noch aus (geplantes Montageende: {plannedEndDate}).",
    MONTAGE_BEHIND_PLAN_SERVICE_CATALOG:
      "Der Leistungsstand liegt bei {actualPercent} % statt der erwarteten {expectedPercent} %: {pendingCount} von {elementCount} Positionen sind noch offen (geplantes Projektende: {plannedEndDate}).",
    // Eine Meldung je Datensatz, nicht je Datei: ein Bagger, dessen vier Nachweise im selben Monat
    // ablaufen, ist eine Sache, um die man sich kümmert. Genannt wird die dringendste Datei — die,
    // von der die Dringlichkeitsstufe kommt — und die Zahl sagt, wie viele noch dranhängen.
    DOCUMENT_DUE: "{count} Dokument(e) zu {ownerTitle} laufen ab, am dringendsten „{fileTitle}“ am {dueDate}.",
  },
  settings: {
    title: "Benachrichtigungen",
    active_count: "{active} von {total} Überwachungen aktiv",
    // Die Abschnitte der Einstellungsseite — gruppiert danach, wohin die Glocke führt.
    groups: {
      billing: "Abrechnung & Berichte",
      costs: "Kosten & Fortschritt",
      operations: "Zeiten & Dokumente",
    },
    // Einheiten hinter den schmalen Zahlenfeldern.
    units: {
      days: "Tage",
      days_before: "Tage vorher",
      points: "Pp.",
    },
    // Die Spalten der Tabelle. „Zeitraum“ ist der Rückblick bzw. das Zeitfenster eines Monitors.
    columns: {
      warning: "Warnung",
      critical: "Kritisch",
      scope: "Zeitraum",
    },
    lookback: "Rückblick",
    unbilled: {
      title: "Nicht abgerechnete Leistungen",
      hint:
        "Meldet ein Projekt, sobald [[hwr:sein ältester nicht abgerechneter/seine älteste nicht abgerechnete/sein ältestes nicht abgerechnetes]] [[hwr]] so viele Tage alt ist. " +
        "Ein Rechnungsentwurf zählt dabei noch nicht als abgerechnet.",
    },
    report_gap: {
      title: "Überfällige [[cr.pl]]",
      hint:
        "Meldet Arbeitstage im Montagezeitraum eines Projekts, für die nach so vielen Tagen noch [[cr:kein/keine/kein]] " +
        "[[cr]] vorliegt. Maßgeblich ist der älteste fehlende Tag.",
      lookback_hint: "Wie weit zurück nach fehlenden Berichten gesucht wird. Ältere Lücken werden nicht mehr gemeldet.",
    },
    loss: {
      title: "Drohende Verluste",
      hint:
        "Meldet Projekte, deren voraussichtliche Marge zu klein wird oder deren Budgetverbrauch dem " +
        "Fertigstellungsgrad davonläuft. Eine negative Marge ist immer kritisch.",
      margin: "Marge unter",
      margin_hint: "Warnung, sobald die voraussichtliche Marge eines Projekts unter diesen Wert fällt.",
      budget_lead: "Budget-Vorlauf",
      budget_lead_hint:
        "Wie weit der Budgetverbrauch dem Fertigstellungsgrad vorauslaufen darf. Ab dem Doppelten kritisch; ohne Fertigstellungsgrad Warnung ab 100 minus diesem Wert % und kritisch ab 100 % Verbrauch.",
    },
    drift: {
      title: "Kostendrift",
      hint:
        "Frühwarnung: Die voraussichtliche Marge eines Projekts ist innerhalb des Zeitfensters um mindestens " +
        "so viele Prozentpunkte gesunken. Sobald ein Verlust droht, übernimmt die Meldung „Drohende Verluste“.",
    },
    montage: {
      title: "Leistungsfortschritt",
      hint: "Verglichen wird der Fertigstellungsgrad des Leistungskatalogs mit einem gleichmäßigen Fortschritt über den Projektzeitraum. Nach dem geplanten Projektende ist eine offene Position immer kritisch.",
    },
    timetracking: {
      title: "Zeiterfassung",
      missing: "Tage ohne Erfassung",
      approval: "Offene Freigabe",
      // Sagt, was gemeldet wird und warum die Meldung nie kritisch wird.
      hint:
        "Meldet Tage ohne Erfassung, Zeiten, die zu lange auf ihre Freigabe warten, und eine Erfassung, " +
        "die niemand gestoppt hat. Feiertage sind im Produkt nicht hinterlegt. Eine Lücke ist deshalb " +
        "ein Hinweis und keine Gewissheit, und die Meldung bleibt eine Warnung.",
      // Sagt, warum es einen Rückblick gibt.
      lookback_hint:
        "Begrenzt, wie weit zurück gesucht wird: ohne ihn meldet der erste Lauf die gesamte Vergangenheit auf einmal.",
    },
    document_due: {
      title: "Ablaufende Dokumente",
      // Erklärt beides auf einmal: warum hier heruntergezählt wird, und warum eine einzelne Datei
      // trotzdem einen eigenen Vorlauf haben darf.
      hint:
        "Gezählt wird bis zum Fälligkeitsdatum, die kritische Stufe liegt also näher daran als die " +
        "Warnung. Einzelne Dateien können im Dateidialog einen eigenen Vorlauf bekommen: Ein " +
        "Führerschein braucht einen Monat, ein Wartungstermin drei Tage. Ein abgelaufenes Dokument " +
        "ist immer kritisch.",
    },
    email: {
      title: "E-Mail-Benachrichtigungen",
      hint: "Bei aktivierter Option werden neue Warnungen und kritische Meldungen automatisch per E-Mail versendet, und zwar an genau die Nutzer, die die Meldung auch in der App sehen dürfen.",
    },
  },
}
